import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { FETCH_USER } from '../actions/types';

const Logout = () => {
    const dispatch = useDispatch();
    
    const handleLogout = useCallback(() => {        
        //this is set in Google Tag Manager
        localStorage.removeItem('fsUserIdSent');
        
        // Clear authentication state
        localStorage.removeItem('isAuthenticated');
        
        // Clear Redux store
        dispatch({ type: FETCH_USER, payload: null });
    }, [dispatch]);

    useEffect(() => {
        const performLogout = async () => {
            try {
                await axios.get(`/api/logout`, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                    timeout: 5000 // 5 second timeout
                });    
            } catch (error) {
                console.error('Logout API call failed:', error);
                // Even if the API call fails, we should still clear local state
            }

            // Always clear local state and redirect, regardless of API call result
            handleLogout();
            
            // Use a small delay to ensure state is cleared before redirect
            setTimeout(() => {
                window.location.assign("/login");
            }, 100);
        };

        performLogout();
    }, [handleLogout]);

    return (
        <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
          <title>Logging Out - Elliot Koss</title>
        </Helmet>
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <div className="text-center">
                <div className="spinner-border text-success" role="status">
                    <span className="visually-hidden">Logging out...</span>
                </div>
                <p className="mt-3">Logging out...</p>
            </div>
        </div>
        </>
    );
};

export default Logout;